import { FormControl, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import LayerUtils from "@vision/core-map-api/src/utils/LayerUtils";
import { Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { BaseViewerService } from "../../viewer-components/services/internal-services/viewer-services/base-viewer.service";
import { IDialogData } from "../../viewer-components/interfaces/i-dialog-data";
import { GeoJSONDatabaseService } from "../../viewer-components/services/internal-services/geojson-database.service";
import { ViewerConfigurationService } from "../../viewer-components/services/viewer-configuration.service";
import { Viewerlayer } from "../../viewer-components/model/viewerlayer";
import { ViewerConstants } from "../../shared/model/viewer-constants";
import { GoogleAnalyticsService } from "../../shared/services/google-analytics.service";

export abstract class WmtsLayerResultsDialogComponent {
  isAuthRequired: boolean = false;

  hide = true;

  layers: any[];

  url: string;

  tilesMatrixSet: any[] = [];

  matrixConfiguration: any;

  username: string = "";

  password: string = "";

  viewerService: BaseViewerService;

  formatPercentLabel = (value: number) => `${value}%`;

  newLayerForm: FormGroup<{ [key: string]: FormControl }>;

  protected constructor(
    protected http: HttpClient,
    protected viewerConfigurationService: ViewerConfigurationService,
    protected geoJSONDatabaseService: GeoJSONDatabaseService,
    protected googleAnalyticsService: GoogleAnalyticsService,
    protected matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
  ) {
    this.url = data.url;
    this.username = data.username;
    this.password = data.password;
    this.isAuthRequired = data.isAuthRequired;
    this.viewerService = data.viewerService;
    this.layers = data.layers;
    this.tilesMatrixSet = data.tilesMatrixSet;
    this.matrixConfiguration = data.matrixConfiguration;
    this.newLayerForm = new FormGroup({});
    this.newLayerForm.addControl(`newLayerName`, new FormControl(""));
    this.newLayerForm.addControl(`selectedLayer`, new FormControl(undefined));
    this.newLayerForm.addControl(`newLayerOpacity`, new FormControl(100));

    for (let index = 0; index < this.layers.length; index++) {
      this.newLayerForm.addControl(`newLayerName-${index}`, new FormControl(`${this.layers[index].Title}`));
    }
  }

  changeCheckLayer(event, layer: any) {
    layer.checked = event.value;
  }

  changeLayerName(event, index) {
    event.preventDefault();
    const layerId = `newLayerName-${index}`;
    this.layers[index].Title = this.newLayerForm.get(layerId).value;
  }

  anyChecked(): boolean {
    return this.newLayerForm.controls.selectedLayer.value;
  }

  editLayerName(layer: any) {
    if (layer.edit) {
      layer.edit = false;
    } else {
      layer.edit = true;
    }
  }

  addWMTSLayers() {
    const url = LayerUtils.removeParam("request", this.url);

    let extraParams;
    const layerNames = [];
    let matrixSet;
    let format;
    let wmtsStyle = "default";
    const selectedLayer = this.newLayerForm.controls.selectedLayer.value;

    if (selectedLayer) {
      layerNames.push(selectedLayer.Identifier);
      matrixSet = document.getElementById(`${selectedLayer.Title}Matrix`).innerText.trim();
      format = document.getElementById(`${selectedLayer.Title}Format`).innerText.trim();

      if (selectedLayer.style && selectedLayer.style.length) {
        wmtsStyle = selectedLayer.style[0].Identifier;
      }
    }

    let matrixIds;
    for (let i = 0; i < this.tilesMatrixSet.length && !matrixIds; i++) {
      if (this.tilesMatrixSet[i].Identifier === matrixSet) {
        matrixIds = this.tilesMatrixSet[i].TileMatrix;
      }
    }

    if (this.isAuthRequired && this.username.length > 0 && this.password.length > 0) {
      extraParams = {
        URL_ORIGIN: url,
        USERNAME: this.username,
        PASSWORD: this.password,
      };
    }
    const layersText = layerNames.join(",");
    let name = selectedLayer.Title;
    if (name.length === 0) {
      name = "Custom WMTS Layer";
    }

    let opacity = this.newLayerForm.controls.newLayerOpacity.value;
    if (!opacity) {
      opacity = 1;
    } else {
      opacity /= 100;
    }

    const layer = {
      source: ViewerConstants.SOURCE_NAME.WMTS,
      url,
      owner: true,
      extraParams,
      panelInclude: true,
      layer: layersText,
      isBase: false,
      opacity,
      visible: true,
      removable: true,
      editable: false,
      realId: `${name.replace(/ /g, "")}_${LayerUtils.layerGuid()}`,
      id: `${name}_${LayerUtils.layerGuid()}`,
      name,
      matrixSet,
      matrixIds,
      imageFormat: format,
      style: wmtsStyle,
      order: ViewerConstants.USER_LAYER_BASE_ZINDEX,
      userId: this.viewerConfigurationService.getViewerConfiguration().userId,
    };

    const layerToSave = LayerUtils.processLayer(layer) as unknown as Viewerlayer;

    this.saveLayer(layerToSave);
    this.matDialog.closeAll();
  }

  enableFormControl(event, layerId) {
    event.preventDefault();
    this.newLayerForm.controls[`newLayerName-${layerId}`].enable();
  }

  abstract saveLayer(layer: Viewerlayer);
}
